import type { NodeKind } from "./buildAccessModel";

export type DropScopeKind = "connected_app" | "skill" | "space";

export const NODE_SCOPE_KIND: Partial<Record<NodeKind, DropScopeKind>> = {
  app: "connected_app",
  skill: "skill",
  space: "space",
};

const isPrincipal = (k: NodeKind) => k === "user" || k === "group";
const isScope = (k: NodeKind) => k === "app" || k === "skill" || k === "space";

// A drop grants access: a principal (user/group) onto a scope grants it a role
// there; a connector/skill onto a space (or vice versa) makes it available to
// the space's members. Everything else (e.g. user→user) is not a valid target.
export function canDrop(source: NodeKind, target: NodeKind): boolean {
  if (source === "user" && target === "group") return true;
  if (isPrincipal(source) && isScope(target)) return true;
  if (isScope(source) && isPrincipal(target)) return true;
  if ((source === "app" || source === "skill") && target === "space")
    return true;
  if (source === "space" && (target === "app" || target === "skill"))
    return true;
  return false;
}
